import { render, staticRenderFns } from "./BiddingNotFOB.vue?vue&type=template&id=81c221b4&"
import script from "./BiddingNotFOB.vue?vue&type=script&lang=js&"
export * from "./BiddingNotFOB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports